import useLock from "../hooks/useLock/use-lock";

export default function LockWrapper({ objectId, children, data, callback }) {
  const { locked } = useLock(objectId, data, callback);

  // children is a function
  return children({ locked });
}
